import axios from '@/axios'

export default {
  getAll(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/cart-items/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getByUserId(id, collectionId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/cart-items/user/${id}?collectionId=${collectionId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  add(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/cart-items`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  adminAdd(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/admin/cart-items`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/cart-items`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  remove(item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/cart-items/${item.cartItemId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
